import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

export const StyledDropdownsFlexContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0 8px;
    margin-top: 8px;
    flex-wrap: wrap;
    & .text-field {
        width: 155px;
        & ${SWReactIcons}[data-automation-icon-name="alert-circle"] {
            right: 40px;
        }
    }
`;

export const StyledDelimiter = styled.div`
    margin: -8px 0;
`;
